const axios = require('axios');

export const add = (docData) => {
    return axios.post('https://e3.eyespy360.com/p/submit_form_enterprise.pl', docData);
}
